import {StackCompat as Stack} from 'components/FluentUICompat';
import React from 'react';
import {UserSettings} from 'components/PersonaButton';
import {HelpButton} from './HelpButton';
import GlobalAnnouncementNavigation from 'features/GlobalAnnouncements/GlobalAnnouncementNavigation';

export const NavigationRight: React.FC = () => {
	return (
		<Stack.Item>
			<Stack horizontal verticalAlign='center'>
				<Stack.Item>
					<GlobalAnnouncementNavigation />
				</Stack.Item>
				<Stack.Item styles={{root: {paddingRight: 10}}}>
					<HelpButton />
				</Stack.Item>
				<Stack.Item>
					<UserSettings />
				</Stack.Item>
			</Stack>
		</Stack.Item>
	);
};
